import React from 'react';
import { withTranslation } from 'react-i18next';
import { Row, Col } from 'react-bootstrap';
import { LoadingButton, DefaultButton } from '../buttons';
import { Checkbox } from '../fields';
import { ModalLayout } from '../layouts';
import { PrizeService } from '../../services';

import '../../styles/modals/modal.css';

class OptionsPrizeModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      show: false,
      prizeTypes: { type: 'BAR', metric: 'AVERAGE_TIME' },
    };

    this.resetFields = this.resetFields.bind(this);
    this.show = this.show.bind(this);
    this.onSaveBtnClick = this.onSaveBtnClick.bind(this);
    this.onTypeOptionChange = this.onTypeOptionChange.bind(this);
    this.onMetricOptionChange = this.onMetricOptionChange.bind(this);

    this.prizeService = new PrizeService();
  }

  componentDidMount() {
    if (this.props.onRef) {
      this.props.onRef(this);
    }
  }

  resetFields() {
    this.setState({
      loading: false,
      show: false,
      prizeTypes: { type: 'BAR', metric: 'AVERAGE_TIME' },
    });
  }

  show(set = true) {
    const { venue } = this.props;

    this.resetFields();
    this.setState({
      show: set,
      prizeTypes: {
        type: venue.prize_types.type,
        metric: venue.prize_types.metric,
      },
    });
  }

  async onSaveBtnClick() {
    const { prizeTypes } = this.state;
    const { venue, onComplete } = this.props;
    const result = await this.prizeService.setOptions(venue ? venue._id : null, prizeTypes.type, prizeTypes.metric);

    if (result && result.success) {
      onComplete(true);
      this.show(false);
    }
  }

  onTypeOptionChange(checked, value) {
    if (checked) {
      this.setState({
        prizeTypes: {
          ...this.state.prizeTypes,
          type: value,
        },
      });
    }
  }

  onMetricOptionChange(checked, value) {
    if (checked) {
      this.setState({
        prizeTypes: {
          ...this.state.prizeTypes,
          metric: value,
        },
      });
    }
  }

  render() {
    const { show, loading, prizeTypes } = this.state;
    const { t } = this.props;

    return (
      show && (
        <ModalLayout title={t('Options')}>
          <Row>
            <Col md={12}>
              <Row>
                <Col md={6}>
                  <p className='prize-container-subtitle'>{t('Type')}</p>
                  <Checkbox text={t('Bar')} value='BAR' checked={prizeTypes.type === 'BAR'} onChange={this.onTypeOptionChange} />
                  <Checkbox text={t('Bartender')} value='BARTENDER' checked={prizeTypes.type === 'BARTENDER'} onChange={this.onTypeOptionChange} />
                </Col>
                <Col md={6}>
                  <p className='prize-container-subtitle'>{t('Metric')}</p>
                  <Checkbox text={t('Average Time')} value='AVERAGE_TIME' checked={prizeTypes.metric === 'AVERAGE_TIME'} onChange={this.onMetricOptionChange} />
                  <Checkbox text={t('Number Sold')} value='NUMBER_SOLD' checked={prizeTypes.metric === 'NUMBER_SOLD'} onChange={this.onMetricOptionChange} />
                </Col>
              </Row>
            </Col>
          </Row>
          <div className='modal-buttons-container'>
            <div className='modal-button'>{loading || <DefaultButton text={t('CANCEL')} onClick={() => this.show(false)} fullWidth></DefaultButton>}</div>
            <div className='modal-button'>
              <LoadingButton text={t('SAVE')} state={loading ? 'LOADING' : 'DONE'} onClick={this.onSaveBtnClick} fullWidth></LoadingButton>
            </div>
          </div>
        </ModalLayout>
      )
    );
  }
}

export default withTranslation()(OptionsPrizeModal);
